import { Component } from '@angular/core';
import { ChartConfiguration, ChartDataset } from 'chart.js';
import { SalesInsightsSeriesResponse } from '../../models/sales-insights.model';
import { salesInsightsSeriesTargets } from '../../utils/sales-insights-targets';
import { salesInsightsRgba, salesInsightsThemeColors } from '../../utils/sales-insights-theme';
import { SalesInsightsSeriesBaseComponent } from '../sales-insights-base/sales-insights-series-base.component';

@Component({
  selector: 'lib-sales-insights-bar-chart',
  standalone: false,
  templateUrl: './sales-insights-bar-chart.component.html',
  styleUrl: './sales-insights-bar-chart.component.scss'
})
export class SalesInsightsBarChartComponent extends SalesInsightsSeriesBaseComponent {
  datasets: ChartDataset<'bar' | 'line', number[]>[] = [];
  chartOptions: ChartConfiguration<'bar'>['options'];

  protected onData(data: SalesInsightsSeriesResponse | null): void {
    const entries = this.visibleEntries(data);
    const theme = salesInsightsThemeColors();
    const bar = { borderRadius: 3, maxBarThickness: 28, categoryPercentage: 0.7, barPercentage: 0.9 };

    this.labels = entries.map(entry => this.formatKey(entry.key));
    this.datasets = [];
    if (this.hasPrevious(entries)) {
      this.datasets.push({
        ...bar,
        label: this.seriesLabel(entries[0]?.previousKey, 'SALES_INSIGHTS_PREVIOUS_PERIOD'),
        data: entries.map(entry => entry.previous?.[this.measure] ?? 0),
        backgroundColor: salesInsightsRgba(this.colorRgb, 0.3),
        hoverBackgroundColor: salesInsightsRgba(this.colorRgb, 0.45)
      });
    }
    this.datasets.push({
      ...bar,
      label: this.seriesLabel(entries[0]?.key, 'SALES_INSIGHTS_CURRENT_PERIOD'),
      data: entries.map(entry => entry.current?.[this.measure] ?? 0),
      backgroundColor: salesInsightsRgba(this.colorRgb, 0.9),
      hoverBackgroundColor: salesInsightsRgba(this.colorRgb, 1)
    });
    const targets = this.measure === 'valueBase' ? salesInsightsSeriesTargets(entries) : null;
    if (targets) {
      this.datasets.push({
        type: 'line',
        label: this.translate.instant('SALES_INSIGHTS_BUDGET'),
        data: targets,
        borderColor: `rgb(${theme.bodyRgb})`,
        backgroundColor: `rgb(${theme.bodyRgb})`,
        borderWidth: 2,
        borderDash: [6, 4],
        pointRadius: 2,
        pointHoverRadius: 4,
        fill: false,
        tension: 0,
        order: -1
      } as ChartDataset<'line', number[]>);
    }
    this.chartOptions = this.baseOptions<'bar'>(theme);
  }
}
